"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEARNOSITY_REPORTS_API = exports.LEARNOSITY_AUTHOR_API = exports.LEARNOSITY_ITEMS_API = void 0;
exports.LEARNOSITY_ITEMS_API = 'LearnosityItems';
exports.LEARNOSITY_AUTHOR_API = 'LearnosityAuthor';
exports.LEARNOSITY_REPORTS_API = 'LearnosityReports';
